import ItemListContainer from './ItemContainer/ItemListContainer';
import ItemDetailContainer from './ItemDetail/ItemDetailContainter';
import Categorias from './Categorias';
import Header from './Header';
import Carrito from "./carrito/Carrito"
import CarritoBtn from "./carrito/CarritoBtn"
import CheckOut from "./carrito/CheckOut"
import { Routes, Route, BrowserRouter } from "react-router-dom";
import { useState, useEffect } from "react";
import PulseLoader from "react-spinners/PulseLoader";
const override = {
  margin: "0px auto",
};
function Main() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 3000);
  })
  return (
    <div>
      {
        loading ?
          <div className="loader-spinner-cont">
            < PulseLoader
              color="#e4555e"
              loading={loading}
              cssOverride={override}
              size={40}
            />
          </div>
          :
          null
      }
      <BrowserRouter >
        <Routes>
          <Route path='/' element={
            <div className="app">
              <Header />
              <Categorias />
              <ItemListContainer />
              <CarritoBtn />
            </div>
          } />
          <Route path="/producto/:id/:type" element={<div className="app"><ItemDetailContainer /></div>} />
          <Route path="/carrito" element={<div className="app"><Carrito /></div>} />
          <Route path="/checkout" element={<div className="app"><CheckOut /></div>} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

/*
SMOOTH SCROLL
  scrollToSection = () => {
  scroller.scrollTo("your_css_class_here", {
    duration: 800,
    delay: 0,
    smooth: "easeInOutQuart",
  });
};
*/


export default Main;